(function () {
  function updateArtworkOption(wrapper) {
    if (!wrapper) return;

    // Enterprise includes a hidden native select behind its custom dropdown.
    const select = wrapper.querySelector('select');
    const upload = wrapper.querySelector('[data-artwork-upload]');
    const file = upload?.querySelector('input[type="file"]');

    if (!select || !upload || !file) return;

    const show = select.value.trim() === 'Upload artwork now';

    upload.hidden = !show;
    file.required = show;

    if (!show && file.files && file.files.length) {
      file.value = '';
    }
  }

  function initArtworkOptions(root) {
    const scope = root || document;

    if (scope.matches?.('.cm-artwork-option')) {
      updateArtworkOption(scope);
    }

    scope.querySelectorAll?.('.cm-artwork-option').forEach(function (wrapper) {
      updateArtworkOption(wrapper);
    });
  }

  // Initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initArtworkOptions(document);
    });
  } else {
    initArtworkOptions(document);
  }

  // Native select change
  document.addEventListener('change', function (event) {
    const wrapper = event.target.closest?.('.cm-artwork-option');

    if (wrapper && event.target.tagName === 'SELECT') {
      setTimeout(function () {
        updateArtworkOption(wrapper);
      }, 0);
    }
  });

  // Enterprise custom-select may update the hidden select programmatically,
  // so also react to clicks inside the artwork dropdown.
  document.addEventListener('click', function (event) {
    const wrapper = event.target.closest?.('.cm-artwork-option');

    if (!wrapper) return;

    setTimeout(function () {
      updateArtworkOption(wrapper);
    }, 50);
  });

  // Quick Buy / drawers are inserted dynamically.
  const observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (!(node instanceof HTMLElement)) return;
        initArtworkOptions(node);
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();